// Major Islamic events with Hijri dates (month/day) — order matters for chronology.
export interface IslamicEvent {
  key: string;
  hMonth: number; // 1..12
  hDay: number;   // day of Hijri month
  name: { en: string; bn: string };
  description: { en: string; bn: string };
}

export const ISLAMIC_EVENTS: IslamicEvent[] = [
  {
    key: "islamic-new-year",
    hMonth: 1, hDay: 1,
    name: { en: "Islamic New Year", bn: "ইসলামি নববর্ষ" },
    description: {
      en: "First of Muharram — start of the Hijri year. Marks the migration (Hijra) of the Prophet (PBUH) from Makkah to Madinah in 622 CE.",
      bn: "১ মুহাররম — হিজরি বছরের শুরু। ৬২২ খ্রিস্টাব্দে মহানবী (সা.)-এর মক্কা থেকে মদিনা হিজরতের স্মরণে।",
    },
  },
  {
    key: "ashura",
    hMonth: 1, hDay: 10,
    name: { en: "Ashura", bn: "আশুরা" },
    description: {
      en: "10th of Muharram. A day of voluntary fasting; commemorates Musa (AS)'s deliverance and the martyrdom of Imam Husain (RA) at Karbala.",
      bn: "১০ মুহাররম। স্বেচ্ছা রোজার দিন; মূসা (আ.)-এর মুক্তি ও কারবালায় ইমাম হুসাইন (রা.)-এর শাহাদাতের স্মরণ।",
    },
  },
  {
    key: "mawlid",
    hMonth: 3, hDay: 12,
    name: { en: "Eid-e-Miladunnabi (Mawlid)", bn: "ঈদে মিলাদুন্নবী" },
    description: {
      en: "12th of Rabi' al-Awwal — observed in Bangladesh as the birthday of Prophet Muhammad (PBUH).",
      bn: "১২ রবিউল আউয়াল — বাংলাদেশে মহানবী (সা.)-এর জন্মদিন হিসেবে পালিত।",
    },
  },
  {
    key: "shab-e-miraj",
    hMonth: 7, hDay: 27,
    name: { en: "Shab-e-Mi'raj", bn: "শবে মিরাজ" },
    description: {
      en: "27th of Rajab — the night of the Prophet's (PBUH) ascension to the heavens, when the five daily prayers were ordained.",
      bn: "২৭ রজব — মহানবী (সা.)-এর ঊর্ধ্বাকাশ ভ্রমণের রাত; পাঁচ ওয়াক্ত নামাজ ফরজ হয়।",
    },
  },
  {
    key: "shab-e-barat",
    hMonth: 8, hDay: 15,
    name: { en: "Shab-e-Barat", bn: "শবে বরাত" },
    description: {
      en: "15th of Sha'ban — the night of forgiveness. Many in Bangladesh spend the night in prayer and recitation.",
      bn: "১৫ শাবান — মাগফিরাতের রাত। বাংলাদেশে অনেকে রাতভর ইবাদত ও তিলাওয়াত করেন।",
    },
  },
  {
    key: "ramadan-begins",
    hMonth: 9, hDay: 1,
    name: { en: "Ramadan begins", bn: "রমাদান শুরু" },
    description: {
      en: "1st of Ramadan — the month of fasting begins, the third pillar of Islam.",
      bn: "১ রমাদান — রোজার মাস শুরু, ইসলামের তৃতীয় স্তম্ভ।",
    },
  },
  {
    key: "lailatul-qadr",
    hMonth: 9, hDay: 27,
    name: { en: "Lailatul Qadr (most likely)", bn: "লাইলাতুল কদর (সম্ভাব্য)" },
    description: {
      en: "27th of Ramadan — most commonly observed odd night. The Qur'an describes it as better than a thousand months.",
      bn: "২৭ রমাদান — সবচেয়ে প্রচলিত বিজোড় রাত। কুরআনে একে হাজার মাসের চেয়ে উত্তম বলা হয়েছে।",
    },
  },
  {
    key: "eid-ul-fitr",
    hMonth: 10, hDay: 1,
    name: { en: "Eid-ul-Fitr", bn: "ঈদুল ফিতর" },
    description: {
      en: "1st of Shawwal — the festival celebrating the end of Ramadan fasting.",
      bn: "১ শাওয়াল — রমাদানের রোজা শেষের উৎসব।",
    },
  },
  {
    key: "day-of-arafah",
    hMonth: 12, hDay: 9,
    name: { en: "Day of Arafah", bn: "আরাফার দিন" },
    description: {
      en: "9th of Dhul-Hijjah — pilgrims gather at Arafat. Fasting on this day is highly recommended for non-pilgrims.",
      bn: "৯ যিলহজ — হাজীগণ আরাফাতে অবস্থান করেন। অ-হাজীদের জন্য এই দিনে রোজা উত্তম।",
    },
  },
  {
    key: "eid-ul-adha",
    hMonth: 12, hDay: 10,
    name: { en: "Eid-ul-Adha", bn: "ঈদুল আযহা" },
    description: {
      en: "10th of Dhul-Hijjah — the festival of sacrifice, commemorating Ibrahim (AS)'s willingness to sacrifice his son.",
      bn: "১০ যিলহজ — কুরবানির ঈদ; ইব্রাহিম (আ.)-এর কুরবানির স্মরণে।",
    },
  },
  {
    key: "hajj-tashreeq",
    hMonth: 12, hDay: 11,
    name: { en: "Days of Tashreeq", bn: "আইয়্যামে তাশরিক" },
    description: {
      en: "11th–13th of Dhul-Hijjah — days of Hajj rites and continued sacrifice. Fasting is forbidden on these days.",
      bn: "১১–১৩ যিলহজ — হজের আনুষ্ঠানিকতা ও কুরবানির ধারাবাহিকতা। এই দিনগুলোতে রোজা নিষেধ।",
    },
  },
];
